import styles from '../styles/PCWindow.module.scss';
import React, {useState, useEffect, useRef} from "react";
import Button from "./Button";
import PCButton from "./PCButton";
import PCButtonSmall from "./PCButtonSmall";
import PCButtonSmaller from "./PCButtonSmaller";
import MessageBubble from "./MessageBubble";
import { useSound } from '../context/SoundContext';
const base = process.env.PUBLIC_URL || ``;

interface PCWindowProps {
    windowType: number,
    windowStartPage?: number,
    cards: string[][];
    cardsHeight: number[][];
    onClick: () => void;
    onClickEnter: () => void;
}
const titles: string[] = [
    "Общий анализ крови",
    "Биохимический анализ крови",
    "Прямая проба Кумбса",
    "Проточная цитометрия",
    "Общий анализ мочи"
]
const tableHeaders: string[][] = [
    [`${base}/images/patirnt1_analiz1_header.jpg`],
    [`${base}/images/patirnt1_analiz2_header.jpg`],
    [`${base}/images/patirnt1_analiz3_header.jpg`],
    [],
    [`${base}/images/patirnt1_analiz5_header.jpg`]
]
const tableHeights: number[] = [
    394,
    361,
    262,
    265,
    394
]


const PCWindow: React.FC<PCWindowProps> = ({windowType, windowStartPage, cards, cardsHeight, onClick, onClickEnter}) =>  {
    const [tableType, setTableType] = useState<number | null>(null);
    const [tableTypeList, setTableTypeList] = useState<number[]>([]);
    const [analyzeTablePage, setAnalyzeTablePage] = useState<number>(0);
    const [listCount, setListCount] = useState<number>(0);
    const analyzeTableScrollRef = useRef<HTMLDivElement>(null);
    const analyzeTableScrollParRef = useRef<HTMLDivElement>(null);
    // @ts-ignore
    const { muted, toggleMuted } = useSound();

    useEffect(() => {
        var ttl = [];
        var ctn = 0;
        if (cards[0].length > 0){
            ctn++
            ttl.push(0)
        }
        if (cards[1].length > 0){
            ctn++
            ttl.push(1)
        }
        if (cards[2].length > 0){
            ctn++
            ttl.push(2)
        }
        if (cards[3].length > 0){
            ctn++
            ttl.push(3)
        }
        if (cards[4].length > 0){
            ctn++
            ttl.push(4)
        }
        setListCount(ctn)
        setTableTypeList(ttl)

        if (windowStartPage){
            handleAnalyzeClick(windowStartPage)
        }
    }, []);

    useEffect(() => {
        const scrollEl = analyzeTableScrollRef.current;
        if (!scrollEl) return;

        let isDown = false;
        let startX: number;
        let scrollLeft: number;

        const mouseDownHandler = (e: MouseEvent) => {
            isDown = true;
            scrollEl.classList.add(styles.activeDrag); // (опционально, для курсора)
            startX = e.pageX - scrollEl.offsetLeft;
            scrollLeft = scrollEl.scrollLeft;
        };

        const mouseLeaveHandler = () => {
            isDown = false;
            scrollEl.classList.remove(styles.activeDrag);
        };

        const mouseUpHandler = () => {
            isDown = false;
            scrollEl.classList.remove(styles.activeDrag);
        };

        const mouseMoveHandler = (e: MouseEvent) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollEl.offsetLeft;
            const walk = (x - startX) * 1; // Скорость прокрутки
            scrollEl.scrollLeft = scrollLeft - walk;
        };

        scrollEl.addEventListener('mousedown', mouseDownHandler);
        scrollEl.addEventListener('mouseleave', mouseLeaveHandler);
        scrollEl.addEventListener('mouseup', mouseUpHandler);
        scrollEl.addEventListener('mousemove', mouseMoveHandler);
        analyzeTableScrollParRef.current!.scrollTop = 0
        analyzeTableScrollRef.current!.scrollLeft = 0

        return () => {
            scrollEl.removeEventListener('mousedown', mouseDownHandler);
            scrollEl.removeEventListener('mouseleave', mouseLeaveHandler);
            scrollEl.removeEventListener('mouseup', mouseUpHandler);
            scrollEl.removeEventListener('mousemove', mouseMoveHandler);
        };
    }, [tableType, analyzeTablePage]);

    const handleAnalyzeClick = (type: number) => {
        if (windowType !== 0){
            var audio = new Audio(`${base}/audio/click.mp3`);
            audio.play()
            setAnalyzeTablePage(0)
            setTableType(type)
        }
    }
    const handlePrevClick = () => {
        if (tableType === null) {return}
        var audio = new Audio(`${base}/audio/click.mp3`);
        audio.play()
        if (analyzeTablePage === 0){
            setAnalyzeTablePage(cards[tableType].length - 1)
        }else {
            setAnalyzeTablePage(analyzeTablePage - 1)
        }
    }
    const handleNextClick = () => {
        if (tableType === null) {return}
        var audio = new Audio(`${base}/audio/click.mp3`);
        audio.play()
        if (analyzeTablePage === cards[tableType].length - 1){
            setAnalyzeTablePage(0)
        }else {
            setAnalyzeTablePage(analyzeTablePage + 1)
        }
    }

    const handlePrevTableClick = () => {
        if (tableType !== null){
            var audio = new Audio(`${base}/audio/click.mp3`);
            audio.play()
            var tTypeIndex = tableType
            tTypeIndex--;
            if (tTypeIndex < 0){
                tTypeIndex = tableTypeList.length - 1
            }
            setTableType(tableTypeList[tTypeIndex])
        }
    }
    const handleNextTableClick = () => {
        if (tableType !== null){
            var audio = new Audio(`${base}/audio/click.mp3`);
            audio.play()
            var tTypeIndex = tableType
            tTypeIndex++;
            if (tTypeIndex > tableTypeList.length - 1){
                tTypeIndex = 0
            }
            setTableType(tableTypeList[tTypeIndex])
        }
    }

    return (
        <div className={styles.Container}
             style={{
                 ...(tableType !== null && {justifyContent: 'flex-start'})
             }}
        >
            <img src={`${base}/images/pcbg.svg`} className={styles.PCBg} alt="pcbg" />

            <div className={styles.PCWindow}
                 style={{
                     ...(tableType !== null && {width: '100%', borderRadius: 0}),
                     ...(tableType !== null && listCount < 3 && {height: "calc(100% - 180px)"}),
                     ...(tableType !== null && listCount >= 3 && {height: "calc(100% - 230px)"})
                 }}
            >
                <div className={styles.PCWindowHeader}>
                    {tableType !== null ?
                        <>
                        <img src={`${base}/images/burger.svg`} className={styles.burger} onClick={()=>{
                            var audio = new Audio(`${base}/audio/click.mp3`);
                            audio.play()
                            setTableType(null)
                        }} alt="burger" />
                        </>
                        :
                        <img src={`${base}/images/burger.svg`} className={styles.burger} alt="burger" />
                    }
                    <img src={`${base}/images/close.svg`} className={styles.close} alt="close" onClick={onClickEnter} />
                </div>

                {tableType === null ?
                    <>
                        {(cards[0].length > 0) && (<PCButton label={"Общий анализ крови"} color={'#BC2B2B'} shadowColor={'#831818'} onClick={()=>handleAnalyzeClick(0)}/>)}
                        {(cards[1].length > 0) && (<PCButton label={"Биохимический анализ крови"} color={'#003FA3'} shadowColor={'#012D73'} onClick={()=>handleAnalyzeClick(1)}/>)}
                        {(cards[2].length > 0) && (<PCButton label={"Прямая проба Кумбса"} color={'#7A43AD'} shadowColor={'#450B67'} onClick={()=>handleAnalyzeClick(2)}/>)}
                        {(cards[3].length > 0) && (<PCButton label={"Проточная цитометрия"} color={'#41951F'} shadowColor={'#28700A'} onClick={()=>handleAnalyzeClick(3)}/>)}
                        {(cards[4].length > 0) && (<PCButton label={"Общий анализ мочи"} color={'#DCB517'} shadowColor={'#BD8120'} onClick={()=>handleAnalyzeClick(4)}/>)}
                    </>
                    :
                    <>
                        <div className={styles.analyzeTitle}>{titles[tableType]}</div>
                        <div className={styles.analyzeTable} style={{height: "calc(100% - 30px)"}} ref={analyzeTableScrollParRef}>
                            <div style={{position:'relative', maxWidth:"100%"}}>
                                <div className={styles.analyzeTableScroll} ref={analyzeTableScrollRef}>
                                    <img src={cards[tableType][analyzeTablePage]} className={styles.analyzeTableImage} alt="analyzeTableImage"
                                         style={{height: cardsHeight[tableType][analyzeTablePage]}}
                                    />
                                </div>
                            </div>
                            <img src={cards[tableType][analyzeTablePage].replace('images/', 'images/analiz_left/').replace('.jpg', '.png')} className={styles.analyzeTableImageLeft} alt="analyzeTableImageLeft"
                                 style={{height: cardsHeight[tableType][analyzeTablePage]}}
                            />
                        </div>
                        {cards[tableType].length > 1 && (
                            <div className={styles.analyzeControl}>
                                <img src={`${base}/images/analyze_arrow.svg`} alt="analyze_arrow" onClick={handlePrevClick}/>
                                <img src={`${base}/images/analyze_arrow.svg`} alt="analyze_arrow" onClick={handleNextClick} style={{transform: "rotate(180deg)"}}/>
                            </div>
                        )}

                    </>
                }



            </div>

            {tableType !== null &&
                <div className={styles.openTableButtons}>
                    {(cards[0].length > 0) && (<PCButtonSmaller label={"ОАК"} color={'#BC2B2B'} onClick={()=>handleAnalyzeClick(0)}/>)}
                    {(cards[1].length > 0) && (<PCButtonSmaller label={"БАК"} color={'#003FA3'} onClick={()=>handleAnalyzeClick(1)}/>)}
                    {(cards[4].length > 0) && (<PCButtonSmaller label={"ОАМ"} color={'#DCB517'} onClick={()=>handleAnalyzeClick(4)}/>)}
                    {(cards[3].length > 0) && (<PCButtonSmall label={"Проточная цитометрия"} color={'#41951F'} onClick={()=>handleAnalyzeClick(3)}/>)}
                    {(cards[2].length > 0) && (<PCButtonSmall label={"Прямая проба Кумбса"} color={'#7A43AD'} onClick={()=>handleAnalyzeClick(2)}/>)}
                </div>
            }

            {windowType === 0 && (
                <div style={{display: 'flex', flexDirection: 'column', gap: '16px', alignItems:'center', height: 'auto'}}>
                    <MessageBubble label="" positionTop={false} text='Принимайте пациентов, назначайте анализы и получайте результаты прямо сюда - на Вашу персональную почту!' textHeight="auto" textIsMaxSize={false} bitTitle={false}/>
                    <div className={styles.stepButtons}>
                        <Button label={"Назад"} redColor={false} answered={false} onClick={onClick}/>
                    </div>
                </div>
            )}
            {windowType === 1 && (
                <img src={`${base}/images/view_card_btn.png`} className={styles.analyzeToCardBtn} onClick={onClick} alt="analyzeToCardBtn" />
            )}

        </div>
    );
}


export default PCWindow;
